import { About } from '@/components/sections/About'
import { Contact } from '@/components/sections/Contact'
import { Hero } from '@/components/sections/Hero'
import { Integrations } from '@/components/sections/Integrations'
import { Services } from '@/components/sections/Services'
import { Stats } from '@/components/sections/Stats'
import { Why } from '@/components/sections/Why'
import { Marquee } from '@/components/motion/Marquee'
import { SERVICE_IDS } from '@/content/services'
import { useTranslations } from '@/app/site-context'

interface HomePageProps {
  onNavigate: (href: string) => void
}

export function HomePage({ onNavigate }: HomePageProps) {
  const { services } = useTranslations()
  const marqueeItems = SERVICE_IDS.map((id) => services.items[id].title)

  return (
    <>
      <Hero onNavigate={onNavigate} />
      <Marquee items={marqueeItems} />
      <Stats />
      <Why />
      <Services />
      <Integrations />
      <Marquee items={marqueeItems.slice().reverse()} reverse variant="outline" speed={80} />
      <About />
      <Contact />
    </>
  )
}
